import React from "react";
import { AppleFilled, AndroidFilled } from "@ant-design/icons";
import { Platform } from "../../types/platform";
import { theme } from "antd";

const { useToken } = theme;

export const PlatformIcon = (props: { platform: Platform | string }) => {
  const { token } = useToken();

  return props.platform === Platform.IOS ? (
    <AppleFilled style={{ fontSize: token.fontSizeLG }}  />
  ) : (
    <AndroidFilled
      style={{ color: "#a4c639", fontSize: token.fontSizeLG }}
      
    />
  );
};
